module.exports = __webpack_public_path__ + "images/search-icon-3961aa550c74efceb04c4b697892ffc7.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/search-icon.svg
// module id = ./client/assets/images/search-icon.svg
// module chunks = 1 6 7 8 9